import dynamic from 'next/dynamic';

import Accordian from './Accordian';
import Alert from './Alert';
import BackButton from './BackButton';
import Button from './Button';
import Error from './Error';
import ErrorMsg from './ErrorMsg';
import Input from './Input';
import Loader from './Loader';
import Modal from './Modal';
import MyInput from './MyInput';
import RestrictedPage from './RestrictedPage';
import SimpleCard from './SimpleCard';
import Tab from './Tab';
import Toast from './Toast';

const Switch = dynamic(() => import('./Switch'));
const MySelect = dynamic(() => import('./MySelect'), { loading: () => 'Loading...' });
const Picker = dynamic(() => import('./DateTimePicker'), { loading: () => 'Loading...' });
const RangePicker = dynamic(() => import('./DateTimeRangePicker'), { loading: () => 'Loading...' });
const UploadMedia = dynamic(() => import('./UploadMedia'), { loading: () => 'Loading...' });

const SingleSelectImage = dynamic(() => import('./SelectImage/single_select'), { loading: () => 'Loading...' });
const MultiSelectImage = dynamic(() => import('./SelectImage/Multi_select'), { loading: () => 'Loading...' });
const WebView = dynamic(() => import('./WebView'));

const Popover = dynamic(() => import('./Popover'));
const ApplicationOnboardingContainer = dynamic(() => import('./ApplicationOnboardingContainer'));

export {
  Button,
  Error,
  Loader,
  Tab,
  SimpleCard,
  Accordian,
  MySelect,
  MyInput,
  Alert,
  Switch,
  Modal,
  Input,
  Toast,
  Picker,
  RangePicker,
  UploadMedia,
  BackButton,
  SingleSelectImage,
  MultiSelectImage,
  WebView,
  RestrictedPage,
  Popover,
  ApplicationOnboardingContainer,
  ErrorMsg
};
